(function(angular){
	'use strict';
	
	angular
		.module('additionalInvestmentReviewModule', [
			'apiModule',
			'coreModule',
			'formValidationModule',
			'progressIndicatorModule'
		])
		.value('globalConfig', globalConfig);
	
})(window.angular);